export const ORGANIZATION_MEMBERSHIP_CODE_TOTAL_DIGITS = 10;
export const ORGANIZATION_MEMBERSHIP_CODE_GROUP_SIZES = [3, 3, 4] as const;

const COMPLETE_CODE_REGEXP = new RegExp(
  `^\\d{${ORGANIZATION_MEMBERSHIP_CODE_TOTAL_DIGITS}}$`,
);

// ちょうど規定桁数の半角数字かどうか。「入力完了した妥当な団体会員コード」の定義をここに集約し、
// 送信ボタンの活性判定（registration / mypage の両フォーム）から参照する。
// スキーマ（codeStrictValidation）は入力途中のエラー表示を避けるため桁数を問わない別判定を持つ。
export const isCompleteOrganizationMembershipCode = (value: string): boolean =>
  COMPLETE_CODE_REGEXP.test(value);

// 数字列を団体会員コードの表示形式（3-3-4）のグループに分割する
export const splitOrganizationMembershipCode = (digits: string): string[] => {
  const groups: string[] = [];
  let offset = 0;
  for (const size of ORGANIZATION_MEMBERSHIP_CODE_GROUP_SIZES) {
    groups.push(digits.slice(offset, offset + size));
    offset += size;
  }
  return groups;
};
